import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FormArgument, AddFormArgument } from '@/models/client/shop-address'

const URL = '/rest/customer/shop/customer-addresses'
const EDIT = '/rest/customer/shop/customer-addresses/{id}'
const GET_URL = '/rest/customer/shop/customer-addresses/{id}'
const DEFAULT = '/rest/customer/shop/customer-addresses/isDefault/{id}'
const LISTALL = '/rest/customer/shop/customer-addresses/getListAll'
const LIST_URL = '/rest/customer/shop/customer-score-orders'

export default {
  add ({form}, cb) {
    let data = convert.toStringify(form, FormArgument)
    http.post(URL, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  putEdit (id, {form}, cb) {
    http.put(EDIT.replace('{id}', id), form).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getAdd (id, cb) {
    http.get(GET_URL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  deleteEdit (id, cb) {
    http.delete(EDIT.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getAll (cb) {
    http.get(LISTALL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  setDefault (id, cb) {
    http.get(DEFAULT.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  addItem ({form}, cb) {
    let postData = convert.toStringify(form, AddFormArgument)
    http.post(LIST_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/shop-address.js